/**
 * Created by Tiger on 21/03/2022.
 */

export const zh = {

    privatisation: '私有化',
    configs_manager: '私有 MQTT 配置',
    private_devices_manager: '下发私有配置',

    second: '秒',
    seconds: '秒',
    minute: '分钟',
    minutes: '分钟',
    hour: '小时',
    hours: '小时',
    config_name: '名称',
    net_type: '接入类型',
    ali_iot: '阿里云 IoT',
    custom_mqtt: '自建 MQTT',
    encrypt_type: '加密方式',
    secret_key: '秘钥',
    no_encrypt: '不加密',
    fixed_encrypt: '固定秘钥',
    report_interval: '定时上报间隔',
    collect_interval: '数据采集间隔',
    ble_interval: '蓝牙广播间隔',
    ble_name: '蓝牙广播名称',
    device_count: '设备数量',
    operations: '操作',
    please_select: '请选择',
    re_select: '重新选择',
    edit_ali_iot_info_tip: '阿里云 IoT 配置信息',
    edit_mqtt_info_tip: '自建 MQTT 配置信息',
    custom_config: '自定义配置',
    add_config: '添加配置',
    add: '添加',
    host_area: '服务器区域',

    config: '配置名称',
    config_message: '请输入配置名称',
    device_type: '设备类型',
    config_status: '配置发送状态',
    config_sent_time: '配置发送时间',
    active_time: '激活时间',
    create_time: '添加时间',
    current_platform: '当前平台',

    add_device: '添加设备',

    //menu
    menu_edit: '编辑',
    menu_delete: '删除',
    change_config: '修改配置',

    //edit config
    config_has_devices: '\'%1\' 配置下有 %2 台设备，需要先解绑设备后，才可删除配置。',
    confirm_to_delete_config: '你确定要删除 %$ 配置吗？',

    //add device
    select_device_type: '选择设备类型',
    select_devices: '选择需要私有化的设备',
    select_devices2: '配置前，请先在"青萍物联" app 中将设备绑定至您的账号。',
    select_config: '选择私有化配置',
    selected_devices_count: '共 @$ 个设备',
    prev: '上一步',
    next: '下一步',

    table_footer: '已选 @$ 个设备',
    confirm_to_delete_device_title: '你确定要删除这 %$ 台设备吗?',
    confirm_to_delete_device_content: '删除后，只是删除了设备和配置的关联关系，不会改变设备的本地配置。如需清除设备本地配置，请将设备恢复出厂设置。',

    delete_success: '删除成功',
    delete_failed: '删除失败',

    edit_success_title: '修改成功',
    edit_success_fail: '修改失败',
    device__edit_success: '共 %0 台设备的配置修改为了 "%1"。请将设备恢复出厂设置，新配置将在恢复出厂设置后联网时远程下发。Wi-Fi 设备请恢复出厂设置后在青萍物联或青萍+ app 中重新配网。',

    add_success_title: '添加成功',
    add_success_fail: '添加失败',
    add_success_sub_title: '私有化配置将在设备联网时远程下发。定时联网的设备，按一下机身按钮可以主动触发联网。',


    access_key_access_secret_tips: 'AccessKey 和 AccessSecret 的获取，请查看',
    access_key_access_secret_tips2: '3.2.3 RAM 访问。',

    product_key_tip: 'ProductKey 的获取，请查看',
    product_key_tip2: '3.2.2 创建产品。',

    mqtt_tips: '使用自建 MQTT 配置，请查看',
    mqtt_tips2: '"3.2 自建 MQTT 服务"。',

    use_thing_model: '使用物模型',

    table_total: '共 %$ 项',

    qingping: '© 青萍科技',

    // private_des: '私有化是指设备直接连接客户指定的服务器。这需要修改固件，是收费服务。',
    no_permission: '您还没有权限。',

    please_contact: '商务合作，请联系:',
    contact_email: '邮箱：',
    contact_tel: '电话：%@',

    // new tabs
    unsent_devices: '未下发',
    sent_devices: '已下发',
    config_send_status: '配置下发状态',
    send_config: '下发配置',
    send_config_success: '下发成功',
    send_config_failed: '下发失败',
    send_config_success_sub_title: '已为 @$ 台设备下发私有化配置，配置将在设备联网时生效。',
    sent: '已下发',
    unsent: '未下发',
    consent: '确定',
    cancel: '取消',
    send_private_mqtt_config: '下发私有 MQTT 配置',
    select_private_config: '选择私有化配置',

    // 编辑 MQTT 配置成功后的提示文案
    mqtt_config_modified_title: '私有 MQTT 配置"%$"已修改',
    attention_label: '注意:',
    mqtt_config_modified_warning: '此配置仅更新云端记录。如需设备生效，请按以下方式操作:',
    wifi_device_step_label: '1. Wi-Fi 设备:',
    wifi_device_step_text: '请将其恢复出厂设置，然后使用青萍物联 App（更多 > 高级 > 配置 Wi-Fi）重新配网，以拉取新配置。',
    nb_iot_device_step_label: '2. NB-IoT / Cat-1 设备:',
    nb_iot_device_step_text: '仅需恢复出厂设置，设备将自动拉取新配置。',
    i_known: '知道了',

    // 已下发 MQTT 列表修改设备 修改成功后的提示文案
    device_config_modified_title: '配置已修改',
    device_config_attention_label: '注意：',
    device_config_warning: '此配置仅更新云端记录。如需设备生效，请按以下方式操作：',
    device_config_wifi_step_label: '1. Wi-Fi 设备：',
    device_config_wifi_step_text: '请将其恢复出厂设置，然后使用青萍物联 App（更多 > 高级 > 配置 Wi-Fi）重新配网，以拉取新配置。',
    device_config_nb_iot_step_label: '2. NB-IoT / Cat-1 设备：',
    device_config_nb_iot_step_text: '仅需恢复出厂设置，设备将自动拉取新配置。',
};
